import { useContext } from 'react';
import styled from 'styled-components';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { useFacetData } from '~/contexts/FacetDataContext';
import FacetPriceRange from './Ranges/FacetPriceRange';
import TradeCard from './TradeCard';

const PanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Panel = styled.div`
  &.price-range {
    width: 100%;
  }
`;

export default function BudgetPrice() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const facetData = useFacetData();
  const defaultPrice = {
    min: facetData?.price?.min ?? 0,
    max: facetData?.price?.max ?? 0
  };
  const price = appliedFilters.price ?? defaultPrice;

  return (
    <>
      <PanelWrapper>
        <Panel className="flex-1 price-range">
          <FacetPriceRange
            className="!max-w-full"
            facetName="price"
            inputWidth={64}
            isCashFormat
            minRange={defaultPrice.min}
            maxRange={defaultPrice.max}
            step={500}
            title="Price Range"
            values={price}
          />
        </Panel>
        <Panel className="flex-1">
          <TradeCard />
        </Panel>
      </PanelWrapper>
    </>
  );
}
